import { render, staticRenderFns } from "./SkuPackingStructureTab.vue?vue&type=template&id=668ddaf7&scoped=true"
import script from "./SkuPackingStructureTab.vue?vue&type=script&lang=js"
export * from "./SkuPackingStructureTab.vue?vue&type=script&lang=js"
import style0 from "./SkuPackingStructureTab.vue?vue&type=style&index=0&id=668ddaf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ddaf7",
  null
  
)

export default component.exports